import { Geometry } from "./Geometry";
import { Polygon as OlPolygon, Point as OlPoint } from "ol/geom";
import { getWidth as OlGetWidth } from "ol/extent";
export class Extent {
    _xmin;
    _ymin;
    _xmax;
    _ymax;
    _crs;
    constructor(xmin, ymin, xmax, ymax, crs) {
        this._xmin = xmin;
        this._ymin = ymin;
        this._xmax = xmax;
        this._ymax = ymax;
        this._crs = crs;
    }
    static fromBbox(bbox, crs) {
        return new Extent(bbox[0], bbox[1], bbox[2], bbox[3], crs);
    }
    static fromGeometries(geometries) {
        if (geometries.length <= 0) {
            return;
        }
        const extent = geometries[0].getExtent();
        geometries.forEach((geom, i) => {
            extent.merge(geom.getExtent());
        });
        return extent;
    }
    getXMin() {
        return this._xmin;
    }
    getYMin() {
        return this._ymin;
    }
    getXMax() {
        return this._xmax;
    }
    getYMax() {
        return this._ymax;
    }
    isPoint() {
        return this._xmin === this._xmax && this._ymin === this._ymax;
    }
    transform(to) {
        if (this._crs !== to) {
            const min = new OlPoint([this._xmin, this._ymin]).transform(this._crs, to);
            const max = new OlPoint([this._xmax, this._ymax]).transform(this._crs, to);
            return new Extent(min.getCoordinates()[0], min.getCoordinates()[1], max.getCoordinates()[0], max.getCoordinates()[1], to);
        }
        return this;
    }
    getBbox(extendBy = 0) {
        return [
            this._xmin - extendBy,
            this._ymin - extendBy,
            this._xmax + extendBy,
            this._ymax + extendBy,
        ];
    }
    merge(extent) {
        if (extent.getXMin() < this._xmin) {
            this._xmin = extent.getXMin();
        }
        if (extent.getYMin() < this._ymin) {
            this._ymin = extent.getYMin();
        }
        if (extent.getXMax() > this._xmax) {
            this._xmax = extent.getXMax();
        }
        if (extent.getYMax() > this._ymax) {
            this._ymax = extent.getYMax();
        }
        return this;
    }
    getWidth() {
        return OlGetWidth([this._xmin, this._ymin, this._xmax, this._ymax]);
    }
    getCentroid() {
        const geometry = Geometry.fromOl(this.toPolygon(), this._crs);
        return geometry.getCentroid();
    }
    toPolygon() {
        const coordinates = [
            [
                [this._xmin, this._ymin],
                [this._xmin, this._ymax],
                [this._xmax, this._ymax],
                [this._xmax, this._ymin],
                [this._xmin, this._ymin],
            ],
        ];
        return new OlPolygon(coordinates);
    }
}
//# sourceMappingURL=Extent.js.map